import axios from 'axios'

export interface Ruang {
  NAMA_RUANG: string
  ID_RUANG: string
}

export const fetchRuang = async (urlAPI: string): Promise<Ruang[]> => {
  try {
    const response = await axios.get(urlAPI + 'ref/ruangselect/001')

    if (response.status === 200) {
      const fetchedData = response.data.response.list
      return fetchedData
    }
  } catch (error) {
    console.error('Error fetch unit:', error)
  }

  return []
}
